import React, { FC } from 'react';
import { Button } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import Modal, {
    ModalFooter,
    ModalHeader,
} from '@/components/Common/Modal';
import styles from './PhoneMissingModal.module.scss';

interface PhoneMissingModalProps {
    isOpen: boolean;
    onCancel: () => void;
    senderEmail: string;
}

const PhoneMissingModal: FC<PhoneMissingModalProps> = ({
    isOpen,
    onCancel,
    senderEmail,
}) => {
    const { t } = useTranslation();
    const nameSpace = 'recipientPage';

    return (
        <Modal
            isOpen={isOpen}
            closeModal={onCancel}
            closable
        >
            <>
                <ModalHeader>
                    <div className={styles.title} data-testid="recipientPage_phoneMissing">
                        {t(`${nameSpace}.OTPSteps.phoneMissing.title`)}
                    </div>
                </ModalHeader>
                <div className={styles.content}>
                    <div className={styles.message}>
                        {t(`${nameSpace}.OTPSteps.phoneMissing.message`)}
                    </div>
                    <div className={styles.message}>
                        <Trans
                            i18nKey={`${nameSpace}.OTPSteps.phoneMissing.contactSender`}
                            t={t}
                            tOptions={{ senderEmail }}
                        >
                            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
                            Please contact <strong>senderEmail</strong> to add your phone number and get access to the files
                        </Trans>
                    </div>
                    <ModalFooter>
                        <div>
                            <Button onClick={onCancel} type="link">
                                {t(`${nameSpace}.OTPSteps.phoneMissing.cancel`)}
                            </Button>
                        </div>
                    </ModalFooter>
                </div>
            </>
        </Modal>
    );
};

export default PhoneMissingModal;
